export const DOCUMENT_DISPLAY_NAME = 'Document';
export const DOCUMENT_TITLE_EDITOR_KEY = 'DOCUMENT_TITLE';
export const DOCUMENT_DEFAULT_TITLE = 'New Document';
export const DOCUMENT_TITLE_CHAR_LIMIT = 60;
